import React from "react"
import PropTypes from "prop-types"

import FsApi from "./fsApi"

const Form = ({ blok, children, prefillValues, onSumbitFormData }) => (
  <FsApi
    blok={blok}
    children={children}
    prefillValues={prefillValues}
    onSumbitFormData={onSumbitFormData}
  />
)

Form.defaultProps = {
  children: [],
}

Form.propTypes = {
  blok: PropTypes.shape({
    formId: PropTypes.string.isRequired,
    thank_you_copy: PropTypes.arrayOf(
      PropTypes.shape({
        copy: PropTypes.string,
      })
    ),
    isParent: PropTypes.bool,
  }).isRequired,
  prefillValues: PropTypes.shape({}),
}

export default Form
